var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.randomImageURL,"alt":"图形验证码","title":"点击切换验证码"},on:{"click":function($event){_vm.t=new Date().getTime()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/Payment/components/components/randImg.vue